<template>
  <fragment>
    <InvoiceFormCard v-if="isMessageVisible" :noBody="false">
      <div class="message">
        <template v-if="isLastUpdatePreviewRequestFailed">
          Cannot display the preview.<br>
          Please ensure all fields are filled in correctly.
        </template>
        <template v-else-if="isWrongAttachedDocTypeMessageVisible || isWrongUploadedDocTypeMessageVisible">Preview is not available for this type of file</template>
        <template v-else-if="isSaveCustomDocMessageVisible">To see preview please save and re-open payout </template>
      </div>
    </InvoiceFormCard>
    <slot v-else></slot>
  </fragment>
</template>

<script>
import InvoiceFormCard from '@components/invoices/form/InvoiceFormCard.vue'
import { PREVIEWABLE_FILE_EXTENSIONS } from '@/constants/invoices'

export default {
  name: 'DocumentPreview',
  components: { InvoiceFormCard },
  props: {
    isCustomTemplateTypeSelected: {
      type: Boolean,
      required: true
    },
    isLastUpdatePreviewRequestFailed: {
      type: Boolean,
      required: true
    },
    /**
     * The name of the file that was previously attached to invoice/payout and saved
     */
    uploadedFileName: String,
    /**
     * The name of the file that was selected using input[type=file] field
     */
    attachedFileName: String,
    attachedFileChanged: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isSaveCustomDocMessageVisible () {
      return this.isCustomTemplateTypeSelected && this.attachedFileName && (!this.uploadedFileName || this.attachedFileChanged)
    },
    isWrongAttachedDocTypeMessageVisible () {
      if (!this.isCustomTemplateTypeSelected) {
        return false
      }

      if (!this.attachedFileName) {
        return false
      }

      const fileExtension = this.attachedFileName.split('.').pop()
      if (!fileExtension) {
        return false
      }

      return !PREVIEWABLE_FILE_EXTENSIONS.includes(`.${fileExtension}`)
    },
    isWrongUploadedDocTypeMessageVisible () {
      if (!this.isCustomTemplateTypeSelected || this.attachedFileName) {
        return false
      }

      if (!this.uploadedFileName) {
        return false
      }

      const fileExtension = this.uploadedFileName.split('.').pop()
      if (!fileExtension) {
        return false
      }

      return !PREVIEWABLE_FILE_EXTENSIONS.includes(`.${fileExtension}`)
    },
    isMessageVisible () {
      return (
        this.isLastUpdatePreviewRequestFailed ||
        this.isSaveCustomDocMessageVisible ||
        this.isWrongAttachedDocTypeMessageVisible ||
        this.isWrongUploadedDocTypeMessageVisible
      )
    }
  }
}
</script>

<style scoped lang="scss">
.message {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  text-align: center;
}
</style>
